// extracted by mini-css-extract-plugin
export var dropdownButton = "_3f-0";
export var fullWidthDropdownButton = "_3f-1";
export var icon = "_3f-3";
export var iconPlaceholder = "_3f-2";
export var menuItemRow = "_3f-9";
export var separator = "_3f-e";
export var shortcutContainer = "_3f-7";
export var shortcutContainerFilled = "_3f-8";
export var shortcutIconLg = "_3f-6";
export var shortcutIconMd = "_3f-5";
export var shortcutIconSm = "_3f-4";
export var submenuChevron = "_3f-d";
export var submenuDropdown = "_3f-a";
export var submenuTriggerRow = "_3f-b";
export var submenuTriggerRowOpen = "_3f-c";